<template>
  <div class="top-bar" @click="toHome">
    <!-- <div class="top_title">数字孪生水电站一张图系统</div>

    <div class="week">
      {{ time[2] }} <span></span> 28.5℃ 多云
      <div class="san"></div>
    </div>
    <div class="time week">
      <div class="san"></div>
      {{ time[0] }} <span></span> {{ time[1] }}
    </div> -->
  </div>
</template>

<script>
import EventBus from '@/eventBus.ts';
export default {
  name: 'TopBar',
  mounted() {},
  methods: {
    toHome() {
      EventBus.$emit('curSideTab', 'home');
      EventBus.$emit('curSideTabIndex', -1);
    },
  },
};
</script>

<script setup>
import { onMounted, ref } from 'vue';

import dayjs from 'dayjs';

const date = ['天', '一', '二', '三', '四', '五', '六'];
const time = ref([
  dayjs().format('HH:mm:ss'),
  dayjs().format('YYYY-MM-DD'),
  `星期${date[dayjs().get('d')]}`,
]);

onMounted(async () => {
  setInterval(() => {
    time.value = [
      dayjs().format('HH:mm:ss'),
      dayjs().format('YYYY-MM-DD'),
      `星期${date[dayjs().get('d')]}`,
    ];
  }, 1000);
});
</script>
<style lang="scss" scoped>
.top-bar {
  width: 3200px;
  height: 80px;
  // background: url('../../assets/hs/bg_大标题.png') no-repeat;
  // background-color: #282829;
  background: linear-gradient(
    to right,
    #0b1f37 0%,
    #0b1f37 12%,
    rgba(0, 0, 0, 0) 30%,
    rgba(0, 0, 0, 0) 75%,
    #0b1f37 88%,
    #0b1f37
  );
  background-size: 100% 100%;
  font-size: 40px;
  font-weight: 700;
  // font-style: italic;
  color: #ffffff;
  // text-shadow: 0 5px 1px rgba(0, 30, 57, 0.39);
  letter-spacing: 32px;
  text-align: center;
  line-height: 80px;
  position: relative;
  cursor: pointer;
  .top_title {
    background: linear-gradient(to bottom, #f6feff, #82aeed);
    -webkit-background-clip: text; /* 使用文字作为背景的剪切区域 */
    -webkit-text-fill-color: transparent; /* 将文字颜色设为透明，使渐变背景可见 */
  }
  .week {
    height: 100%;
    position: absolute;
    left: 10px;
    top: 0;
    font-size: 14px;
    font-weight: 300;
    color: #ffffff;
    letter-spacing: 0;
    text-shadow: none;
    font-style: normal;
    span {
      display: inline-block;
      width: 1px;
      height: 16px;
      background: #819bc8;
      line-height: 48px;
      margin: 16px 4px 0 4px;
      vertical-align: top;
    }
    .san {
      display: inline-block;
      width: 10px;
      height: 13px;
      // background: url('../../assets/mls/sjx.png') no-repeat;
      margin-left: 4px;
    }
  }
  .time {
    left: unset;
    right: 10px;
    .san {
      transform: rotate(180deg);
    }
  }
}
</style>
